// extracted by mini-css-extract-plugin
export default {"card":"SkeletonLoader_card__0mW7v","back":"SkeletonLoader_back__ggs2D","skeleton-animation":"SkeletonLoader_skeleton-animation__3nfax"};